export default __webpack_public_path__ + "static/media/fectum-logo.ce8f82fa.png";